import { OperationType } from '@global-enum/GeneralUtility';

export class ValidationResponseModel {
  public Status: OperationType;
  public Message: string;

  constructor() { }

}